import React from 'react'
import { Box } from '@mui/material'
import Hero from '@/components/Hero'
import Plans from '@/components/Plans'
import UltraFastSection from '@/components/UltraFastSection'
import CoverageSection from '@/components/CoverageSection'
import Testimonials from '@/components/Testimonials'
import HelpSection from '@/components/HelpSection'
import SEO from '../components/SEO'
import { seoConfig } from '../config/seo'

const HomePage: React.FC = () => {
  return (
    <>
      <SEO {...seoConfig.home} />
      <Box sx={{ bgcolor: '#1E2227' }} id="main-content">
        <Hero />
        <UltraFastSection />
        <Plans />
        <Testimonials />
        <CoverageSection />
        <HelpSection />
      </Box>
    </>
  )
}

export default HomePage
